import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../../core/services/user.service';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { FileSizeExceedAlertComponent } from '../file-size-exceed-alert/file-size-exceed-alert.component';
import { ProfileDataService } from '../../../core/services/profile-data.service';
import { CommonAlertComponent } from '../../../shared/components/common-alert/common-alert.component';
import { ToastrService } from 'ngx-toastr';
import { EllipsisPipe } from '../../pipes/ellipsis.pipe';
import { AttachmentViewDirective } from '../../directives/attachment-view.directive';
import { NgClass } from '@angular/common';
import { ApiDatePipe } from '../../pipes/api-date.pipe';
import { HttpResponse } from '@angular/common/http';
import { parseApiDate } from '../../../core/utils/date.util';

@Component({
    selector: 'add-resumes-modal',
    templateUrl: './add-resumes-modal.component.html',
    styleUrls: ['./add-resumes-modal.component.scss'],
    imports: [NgClass, AttachmentViewDirective, ApiDatePipe, EllipsisPipe]
})
export class AddResumesModalComponent implements OnInit {

	private ssnUrl = environment.urls.ssnUrl_Obj;

	@Input() resumeName: string = '';
	@Input() isJobApplication: boolean = false;
	@Output() saveResume: EventEmitter<any> = new EventEmitter<any>();
	@Output() deleteResume: EventEmitter<any> = new EventEmitter<any>();
	@Output() dataChange: EventEmitter<any> = new EventEmitter<any>();
	@Output() cancelAction: EventEmitter<boolean> = new EventEmitter<boolean>();
	public Deactivation:boolean=false
	public enableUploadInEdit: boolean = false;
	public uploadAttachment: boolean = true;
	public disableSave: boolean = true;
	public uploading: boolean = false;
	public showUploaded: boolean = false;
	public enableSave: boolean = false;
	public enableDelete: boolean = false;
	public hideSaveButton: boolean = false;
	public editInProgress: boolean = false;

	public fileServerUrl: string = environment.urls.fileServerUrl_Obj;
	public UserName: string = '';
	public fileName: string = '';
	public fileData: any;
	public ResumeData: any[] = [];
	isProcessing: boolean = false;

	constructor(private element: ElementRef,
		public modal: NgbActiveModal,
		private userService: UserService,
		private cookieService: CookieService,
		private modalService: NgbModal,
		private profileDataService: ProfileDataService,
		private toastr: ToastrService) { }

	ngOnInit() {
		this.fileName = this.resumeName;
		const cached = this.cookieService.get('username');
		if (cached) {
			this.UserName = cached;
		} else {
			this.userService.profileInfo().subscribe((response: any) => {
				if (response?.Data?.BasicInformation?.FullName) {
					this.UserName = response.Data.BasicInformation.FullName;
					this.userService.setCookie('username', this.UserName, false);
				}
			});
		}
		this.ResumeSort(0);
	}

	previewAttachmentView(file: any) {

		if (file) {
			const allowedTypes = [
				'application/pdf',
				'application/msword',
				'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
			];
			if (!allowedTypes.includes(file.type)) {
				let modal = this.modalService.open(FileSizeExceedAlertComponent, { windowClass: 'alert-popup-common', backdrop: 'static', keyboard: false });
				modal.componentInstance.msg = 'Only PDF, DOC, and DOCX files are allowed.';
				const fi1 = this.element.nativeElement.querySelector('input[type="file"]');
				if (fi1) fi1.value = null;
				return;
			}
			if (file.size <= 2000000) {
				if (true) {
					this.uploading = true;
					this.uploadAttachment = false;
					file.uploadUrl = `${this.ssnUrl}profile/resume/upload`;
					this.userService.uploadAttachment(file).subscribe((response: any) => {
						if (response.Code === 200) {
							this.fileData = response.Data;
							this.fileName = this.cookieService.get('username');
							this.uploading = false;
							this.showUploaded = true;
							this.disableSave = false;
							this.enableSave = true;
							// Check if user update a file after click the delete
							if (this.enableDelete) {
							this.enableDelete = false;
						}
						} else {
							this.uploadAttachment = true;
							this.uploading = false;
						}
					})
				}
			} else {
				this.fileSizeExceed();
				const fi2 = this.element.nativeElement.querySelector('input[type="file"]');
				if (fi2) fi2.value = null;
			}
		}
	}

	private fileSizeExceed() {
		let modal = this.modalService.open(FileSizeExceedAlertComponent, { windowClass: 'alert-popup-common', backdrop: 'static', keyboard: false });
		modal.componentInstance.msg = 'Your file is too large. The maximum size is 2 MB.';
	}

	getAttachmentViewUrl(url: string): string {
    if (!url || url === null || url === undefined) {
      return '';
    }
    return this.fileServerUrl+url;
  }

	// Clear Attachment in initail upload
	updateResume(resumeId: any, deactivate: boolean,fileName:any) {
		this.Deactivation = true

		let modal = this.modalService.open(CommonAlertComponent, { backdrop: 'static', keyboard: false });
		modal.componentInstance.header = deactivate ? 'Deactivate Resume Request' : 'Activate Resume Request';
		modal.componentInstance.msg = deactivate
			? `You are about to deactivate the "${fileName}" resume. Ensure you upload a new one or activate an existing resume.`
			: `You are about to activate the "${fileName}" resume.`;
		modal.componentInstance.confirmButton = 'OK';
		modal.componentInstance.cancelButton = 'Cancel';
		modal.componentInstance.showCancelButton = true;

		modal.result.then(
			(result) => {
				if (result === 'OK') {

					if (deactivate) {
						this.enableSave = true;
						this.dataChange.emit(null); // Emit a change event for deactivation
						this.toastr.success(`Resume deactivated.`);
					} else {
						this.enableSave = true;
						let obj = this.ResumeData.find(resume => resume.resume_id === resumeId);
						this.dataChange.emit(obj);
						this.toastr.success(`Resume activated.`);
						this.profileDataService.setEditResumeId(obj.resume_id);
						this.profileDataService.setResumeUrl(obj.attachment_url);
					}
					this.ResumeSort(resumeId);
				}
			},
			() => {
				// User dismissed the modal, no action needed
			}
		);
		// this.modal.dismiss();
	}
	// Resume Data Sort
	ResumeSort(resumeId: any){
		this.userService.updateResume(resumeId).subscribe((response: any) => {
			this.ResumeData = response.Data;
			this.ResumeData.sort((a, b) => {
				// The current (active) resume always sits on top
				if (a.status !== b.status) {
					return a.status ? -1 : 1;
				}
				// Everything else: most recently updated first. parseApiDate is the
				// same normalizer the apiDate pipe uses, so the order always matches
				// the dates shown in the Last Updated column.
				const aTime = parseApiDate(a.updated_at)?.getTime() ?? 0;
				const bTime = parseApiDate(b.updated_at)?.getTime() ?? 0;
				if (aTime !== bTime) {
					return bTime - aTime;
				}
				// Undated or same-timestamp rows fall back to a stable name order
				return (a.file_name || '').localeCompare(b.file_name || '');
			});
		});
	}

	// Save attachment
	save() {
		if (this.isJobApplication) {
			let modal = this.modalService.open(CommonAlertComponent, { backdrop: 'static', keyboard: false });
			modal.componentInstance.header = 'Update Profile Resume?';
			modal.componentInstance.msg = 'This will set the selected resume as your active profile resume and use it for this application. Continue?';
			modal.componentInstance.confirmButton = 'Yes, Continue';
			modal.componentInstance.cancelButton = 'Cancel';
			modal.componentInstance.showCancelButton = true;
			modal.result.then(
				() => { this.doSave(); },
				() => {}
			);
		} else {
			this.doSave();
		}
	}

	private doSave() {
		if(this.fileData){
			let objToUpload = {
				resume: {
					attachment_type: this.fileData.attachment_type,
					attachment_url: this.fileData.attachment_url,
					file_name: this.fileData.file_name,
					co_guid: ''
				}
			};
			this.uploading = true;
			this.userService.addComponent(objToUpload).subscribe((response: any) => {
				this.uploading = false;
				if (response.Code === 200) {
					this.saveResume.emit({ data: this.fileData });
					if (!this.isJobApplication && response.Data?.Resume) {
						this.profileDataService.setEditResumeId(response.Data.Resume.Id);
						this.profileDataService.setResumeUrl(this.fileData.attachment_url);
					}
				}
				this.modal.dismiss();
			});
		}
		else{
			this.saveResume.emit({ data: null });
			this.modal.dismiss();
			this.toastr.success(`Resume activated.`);
		}
	}
	onDownload(event: Event, attachURL: string) {
		// event.preventDefault(); // Prevent default anchor click behavior
		if (this.isProcessing) {
		  return; // Prevent multiple simultaneous calls
		}

		this.isProcessing = true;

		// this.userService.processAttachmentUrl(attachURL).subscribe({
		//   next: (modifiedUrl) => {
		// 	window.location.href = modifiedUrl; // Redirect to the modified URL
		//   },
		//   error: (err) => {
		// 	const trans=this.fileServerUrl+attachURL.replace('resumes', 'watermark').replace(/\.docx?|\.txt|\.rtf|\.odt|\.html|\.pdf$/i, '.pdf');
		// 	window.location.href =trans
		//   },
		//   complete: () => {
		// 	this.isProcessing = false; // Re-enable the link
		//   },
		// });
		this.userService.convertFiletopdf(attachURL).subscribe(
					(res: HttpResponse<string>) => {
					  if (res.status === 200) {
						const transformedUrl = this.fileServerUrl+attachURL.replace('/jobresumes/', '/watermark/').replace('/resumes/', '/watermark/').replace(/\.docx?|\.txt|\.rtf|\.odt|\.html|\.pdf$/i, '.pdf');
						window.location.href= transformedUrl;
						this.isProcessing = false;
					  }
					  else{

					  }

					},
					(error) => {
					  this.toastr.error(error?.error?.Message || error?.message || 'An unexpected error occurred. Please try again.');
					  window.location.href=this.fileServerUrl+attachURL
					  this.isProcessing = false;
					}
				  );

	  }
	// Update attachment
	update() {
		// start uploading
		// let obj = this.fileData
		// let objToUpload = {
		// 	UpdateRecords: [
		// 		{
		// 			Type: 'RESUME',
		// 			Data: {
		// 				Id: this.profileDataService.getEditResumeId(),
		// 				attachment_type: obj.attachment_type,
		// 				attachment_url: obj.attachment_url,
		// 				file_name: obj.file_name,
		// 				co_guid: ''
		// 			}
		// 		}
		// 	]
		// };

		// this.userService.profileUpdate(objToUpload).subscribe((response: any) => {
		// 	if (response.Code === 200) {
		// 		this.saveResume.emit({ data: this.fileData });
		// 	}
		// })

		// this.modal.dismiss();
		this.save();


	}

	// Delete Attachment
	delete() {
		let objToDelete = {
			DeleteIds: [{
				Type: 'RESUME',
				Id: this.profileDataService.getEditResumeId()
			}]
		};

		this.userService.profileUpdate(objToDelete).subscribe((response: any) => {
			if (response.Code === 200) {
				this.deleteResume.emit({ data: null })
			}
		})
		this.modal.dismiss();
	}

	onFileChange(event: any) {
		if (event.target.files.length > 0) {
			this.previewAttachmentView(event.target.files[0]);
		}
	}

	closeThisDialog() {
		if (this.isJobApplication) {
			this.cancelAction.emit(this.ResumeData.length > 0);
		}
		this.modal.dismiss();
	}

}
